import { Unionize } from 'utilitys/helpers/TsGeneral';
import { StateCreator, create } from 'zustand';

interface Props {
    username: string | null;
    password: string | null;
    update: (value: Unionize<Omit<Props, 'update'>>) => void;
}
const state: StateCreator<Props> = (set) => ({
    username: null,
    password: null,
    update: (value) => set({ ...value }),
});
export const useLoginStore = create(state);
